import React from "react"
import types from "prop-types"
import SvgSpriteIcon from "shared/SvgSpriteIcon"

const BellIcon = ({ className = "w-8 h-8", ...rest }) => <SvgSpriteIcon iconName="bell" className={className} {...rest} />

BellIcon.propTypes = {
  className: types.string,
}

export default BellIcon
